<template>
  <AppHeaderDropdown class="custom-header-menu" right no-caret>
    <template slot="header">
      <span class="mr-5 color-white role-bedge">{{ sessionName() }}</span>
      <img
        :src="`/placeholder.png`"
        class="img-avatar"
        alt="paradigm-img" />
    </template>\
    <template slot="dropdown">
      <!-- show only in mobile -->
      <b-dropdown-item class="d-sm-none" @click="openMenuApproval()"><i class="icon-list"></i> Approvals</b-dropdown-item>
      <b-dropdown-header
        tag="div"
        class="text-center font-13 pb-5 pt-5">
        <div>Settings</div>
      </b-dropdown-header>
      <b-dropdown-item v-if="paradigm_role_id == '4' || paradigm_role_id == '3'" @click="editProfile()"><i class="fa fa-user" /> Edit Profile</b-dropdown-item>
      <b-dropdown-item v-else @click="$router.push('/change-password')"><i class="fa fa-lock"/> Change Password</b-dropdown-item>
      <!-- <b-dropdown-item><i class="fa fa-wrench" /> Change Password</b-dropdown-item> -->
      <b-dropdown-item @click="logout()"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<style lang="scss">
.custom-header-menu {
  // set ul witdh to 150px for mobile
  @media (max-width: 575px) {
    .dropdown-menu {
      width: 160px;
    }
  }
}
</style>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      allUserRole: [],
      itemsCount: 42,
      paradigm_role_id: Auth.Session.get().paradigm_role
    }
  },
  created () {
    axios.get('vendor/v1/user_role').then(response => {
      this.allUserRole  = response.data.data.rows
      // console.log('test', response.data.data.rows)
    }).catch(error => {
      console.log('error', error)
    })
  },
  methods: {
    openMenuApproval() {
      this.$router.push('/approval?id=' + Auth.Session.get().paradigm_id)
    },
    sessionRole () {
      for(var i = 0; i < this.allUserRole.length; i++) {
        if (Auth.Session.get().paradigm_role == this.allUserRole[i].id) {
          return ((this.allUserRole[i].name).replace('_', ' ')).toUpperCase()
          break
        }
      }
    },
    sessionName () {
      return Auth.Session.get().paradigm_login_name || '-'
    },
    editProfile () {
      if (Auth.Session.get().paradigm_role === '4' || Auth.Session.get().paradigm_role === '3') {
        this.$router.push('/sales/edit?id=' + Auth.Session.get().paradigm_id)
      } else if (Auth.Session.get().paradigm_role === '1' || Auth.Session.get().paradigm_role === '2') {
        this.$router.push('/admin/edit?id=' + Auth.Session.get().paradigm_id)
      } else if (Auth.Session.get().paradigm_role === '6') {
        this.$router.push('/customerService/edit?id=' + Auth.Session.get().paradigm_id + '&isChangePassword=1')
      }
    },
    logout () {
      Auth.Session.delete()
      window.location.href = '/login'
      // if (Auth.Session.get().paradigm_role === '4' || Auth.Session.get().paradigm_role === '3') {
      //   Auth.Session.delete()
      //   // this.$router.push('/login/sales')
      //   window.location.href = '/login/sales'
      // } else if (Auth.Session.get().paradigm_role === '6') {
      //   Auth.Session.delete()
      //   // this.$router.push('/login/sales')
      //   window.location.href = '/login/cs'
      // } else {
      //   Auth.Session.delete()
      //   window.location.href = '/login'
      // }
    }
  }
}
</script>
